import { appPath } from './addressing/paths.js';

/**
 * I-2453: the parts of the shell contract a first screen reads, in a module that imports nothing of
 * the contract itself (`shell-bridge.ts`) or the route table (`shell-route-table.ts`). Both re-export
 * these, so every existing import is unchanged; a module the launch loads statically imports them
 * from here, or the contract and the table come back into the entry chunk
 * (`scripts/check-first-screen-chunks.mjs`, ToolbarPlaces and ShellRouteTable).
 */

/** `window.webkit.messageHandlers.featit`: where the web posts its messages on iOS. */
export const SHELL_MESSAGE_HANDLER_NAME = 'featit';

/**
 * `FEATitShell/<version> (iOS; phone|pad)`, appended to the user agent.
 *
 * ⛔ **For server logs, the edge log and naming a sign-in in Devices only** (I-1034,
 * `credentialClient.ts`: a stored user agent is all an old session has to be named by). The web
 * decides shell mode from the injected
 * descriptor, never from this token — a guard in the web (`shellDetection.guard.test.ts`) fails on a
 * user-agent branch. A token is a string anyone can send; the descriptor is only there when the
 * shell put it there.
 */
export const SHELL_USER_AGENT_PRODUCT = 'FEATitShell';

/** The app scope's value for every work area at once; otherwise a scope is one work area's id. */
export const SHELL_ALL_WORK_AREAS_SCOPE = 'all';

/** A path without its query and fragment. */
export function shellPathname(path: string): string {
  return path.split('#', 1)[0].split('?', 1)[0] || '/';
}

/**
 * F-0530 (AC-19.4): where the native switcher's Edit opens — the web's own work-area management,
 * its edit mode, as a page. Read by the contract (`shell-bridge.ts`) and the route table
 * (`shell-route-table.ts`), each of which a screen may load without the other (I-2453).
 */
export const SHELL_WORK_AREA_EDIT_PATH = appPath('/work-areas/edit');
